import 'bootstrap/dist/css/bootstrap.min.css';
import 'remixicon/fonts/remixicon.css'; 
import 'react-tabs/style/react-tabs.css';

import "semantic-ui-css/semantic.min.css";

import "../src/scss/trezo/style.scss";

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render( <App />);

reportWebVitals();
